<template>

    <app-layout :title="__('User')">

        <update-profile-information-form
            :user="$page.props.user">
        </update-profile-information-form>

        <update-password-form class="" />

    </app-layout>

</template>

<script>

import { defineComponent } from 'vue'
import AppLayout from '../../Layouts/AppLayout.vue'
import UpdatePasswordForm from './Partials/UpdatePasswordForm.vue'
import UpdateProfileInformationForm from './Partials/UpdateProfileInformationForm.vue'

export default defineComponent({

    props: ['sessions'],

    components: {
        AppLayout,
        UpdatePasswordForm,
        UpdateProfileInformationForm,
    },

})

</script>
